var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 20,
    viewBox: "0 0 34 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.778 12.2206L22.669 10.3296L20.7598 8.42043C20.5256 8.18615 20.5238 7.80798 20.7558 7.57594L21.176 7.15571C21.4081 6.92367 21.7862 6.92548 22.0205 7.15976L23.9297 9.06894L25.8207 7.17794C26.0527 6.9459 26.4309 6.94771 26.6652 7.18198L27.0895 7.60624C27.3237 7.84052 27.3255 8.21869 27.0935 8.45073L25.2025 10.3417L27.1117 12.2509C27.3459 12.4852 27.3478 12.8634 27.1157 13.0954L26.6955 13.5156C26.4634 13.7477 26.0853 13.7459 25.851 13.5116L23.9418 11.6024L22.0508 13.4934C21.8188 13.7255 21.4406 13.7236 21.2063 13.4894L20.7821 13.0651C20.5478 12.8308 20.546 12.4527 20.778 12.2206Z",
    fill: "url(#paint0_linear_109_223)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8827 16.1541C19.2093 14.4572 20 12.3209 20 10C20 7.67909 19.2093 5.54284 17.8827 3.84593C19.3821 2.4523 21.3915 1.6 23.6 1.6C28.2392 1.6 32 5.36081 32 10C32 14.6392 28.2392 18.4 23.6 18.4C21.3915 18.4 19.3821 17.5477 17.8827 16.1541ZM16.8 2.66782C15.0157 1.01224 12.6261 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C12.6261 20 15.0157 18.9878 16.8 17.3322C18.5843 18.9878 20.9739 20 23.6 20C29.1228 20 33.6 15.5228 33.6 10C33.6 4.47715 29.1228 0 23.6 0C20.9739 0 18.5843 1.01224 16.8 2.66782Z",
    fill: "url(#paint1_linear_109_223)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86068 13.8388L5.74068 10.7188C5.55324 10.5314 5.55324 10.2275 5.74068 10.04L6.41949 9.36117C6.60693 9.17371 6.91087 9.17371 7.09831 9.36117L9.20009 11.4629L13.7019 6.96118C13.8893 6.77373 14.1933 6.77373 14.3807 6.96118L15.0595 7.64C15.247 7.82745 15.247 8.13136 15.0595 8.31883L9.53951 13.8388C9.35204 14.0263 9.04813 14.0263 8.86068 13.8388V13.8388Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_223",
    x1: 29.2624,
    y1: 15.446,
    x2: 17.2036,
    y2: 16.4966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8258F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_109_223",
    x1: 16.1824,
    y1: 27.5715,
    x2: 37.2589,
    y2: -2.44742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8258F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7CFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.33f3c7b95d0e9331d741f2b7a1fa562d.svg";
export { ForwardRef as ReactComponent };